import { Link } from '@tanstack/react-router';

import { PublicLayout } from './layouts/PublicLayout';
import { Center, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function PageNotFound() {
  const { t } = useTranslation();
  return (
    <PublicLayout>
      <Center>
        <Stack mt='200'>
          <Title>{t('pages.notFound.title')}</Title>
          <Text>{t('pages.notFound.message')}</Text>
          <Link to='/'>{t('common.goHome')}</Link>
        </Stack>
      </Center>
    </PublicLayout>
  );
}
